import React, { useMemo } from "react";

import { GetAllClientWorkflowsByClientId } from "data/hub/clientWorkflows/actions";

import { useFeatures } from "components/FeatureFlag";

import useNewHublyApp from "scenes/Hubly/useNewHublyApp";

import { getClientWorkflowsByClientId } from "../../../Workspace/api";

function prepareResolver(queryNumComments) {
  return async ({ hub, clientId }) => {
    const clientWorkflows = await getClientWorkflowsByClientId(
      {
        hubId: hub.hubId,
        clientId: clientId,
      },
      queryNumComments
    );
    return [clientWorkflows, true];
  };
}

async function resolveLegacyClientWorkflow({
  hub,
  clientId,
  skippedLegacy = false,
}) {
  if (skippedLegacy) return [[], false];
  const clientWorkflows = await GetAllClientWorkflowsByClientId(
    { id: hub.id },
    clientId
  );
  return [clientWorkflows, true];
}

export function withClientWorkflowResolver(Component) {
  return (props) => {
    const { loadingConfig, newApp } = useNewHublyApp();
    const commentFiltersEnabled = useFeatures("comment-filters", undefined);

    const resolve = useMemo(() => {
      return newApp
        ? prepareResolver(commentFiltersEnabled)
        : resolveLegacyClientWorkflow;
    }, [newApp, commentFiltersEnabled]);

    if (loadingConfig || commentFiltersEnabled === undefined) return null;

    return (
      <Component
        {...props}
        resolveClientWorkflow={resolve}
        showCwfLoader={newApp}
      />
    );
  };
}

export default withClientWorkflowResolver;
